import { writable } from "svelte/store";

const defaults = {
    name: "",
    surname: "",
    company: "",
    email: "",
    privacy: false
};

const contact = writable({ ...defaults });

export { contact, defaults };